@if(showBanner) {
    <div
        class="{{overrideClass}}" [ngClass]="{
        alert: bannerType === 'alert',
        error: bannerType === 'error',
        warning: bannerType === 'warning',
        important: bannerType === 'important',
        confirmation: bannerType === 'confirmation',
        info: bannerType === 'info',
        search: bannerType === 'search',
        additionalInfo: bannerType === 'additionalInfo',
        'extended-margin': extendMargin,
        'extended-height': extendHeight,
    }">
        <div class="banner-message">
            @if(!hideIcon) {
                @if(bannerType === 'warning' || bannerType === 'important' || bannerType === 'additionalInfo') {
                    <mat-icon class="svg-icon" [svgIcon]="bannerIcons[bannerType]" inline="true"></mat-icon>
                }

                @if(bannerType !== 'warning' && bannerType !== 'important' && bannerType !== 'additionalInfo') {
                    <mat-icon inline="true">{{ bannerIcons[bannerType] }}</mat-icon>
                }
            } @else {
                <div class="icon-placeholder"></div>
            }
            <span class="{{messageOverrideClass}}" [innerHtml]="bannerMessage | sanitizer" [attr.data-qa-id]="dataQaId"></span>
        </div>

        <ng-container
            [ngTemplateOutlet]="optionTemplate">
        </ng-container>

        @if(closeEnabled) {
            <button class="close-button" (click)="onClose()" aria-label="Close banner">
                <mat-icon>close</mat-icon>
            </button>
        }
    </div>
}
